import React from 'react';
import HeroSection  from '../components/HeroSection';
import HeroIntroSection from '../components/HeroIntroSection';
import WorkSection from '../components/WorkSection';
import CapacitiesSection from '../components/CapacitiesSection';
import CreativeLibrarySection from '../components/CreativeLibrarySection';

const Home: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <HeroIntroSection />
      <WorkSection />
      <CapacitiesSection />
      <CreativeLibrarySection />
    </div>
  );
};

export default Home; 
